import * as types from "./ActionTypes";
import api from "../api/UrlApi";
import UrlHelper from "../utilities/UrlHelper";

export const getAvailableApplications = () => {
    const returnUrl = UrlHelper.parseUrl().query.returnUrl;
    return (dispatch) => {
        return api.getAvailableApplications(returnUrl)
            .then((apps) => {
                dispatch({ type: types.GET_AVAILABLE_APPLICATION_SUCCEEDED, apps });
            })
            .catch((error) => {
                dispatch({ type: types.GET_AVAILABLE_APPLICATION_FAILED });
                throw(error);
            });
    };
};

export const getSuperUserLinks = () => {
    return (dispatch) => {
        return api.getSuperUserLinks()
            .then((links) => {
                dispatch({ type: types.GET_SUPERUSER_LINKS_SUCCEEDED, links });
            })
            .catch((error) => {
                dispatch({ type: types.GET_SUPERUSER_LINKS_FAILED, error });
                throw(error);
            });
    };
};


export const getApplicationLinks = (showLoginPageUrls) => {
    return (dispatch) => {
        return api.getApplicationLinks(showLoginPageUrls)
            .then((appLinks) => {
                dispatch({ type: types.GET_APPLICATION_LINKS_SUCCEEDED, appLinks, showLoginPageUrls });
            })
            .catch((error) => {
                dispatch({ type: types.GET_APPLICATION_LINKS_FAILED, error });
                throw(error);
            });
    };
};
